import React, { useEffect, useRef, useState } from 'react';
import './Dashboard.css';
import { Link, useNavigate } from 'react-router-dom';
import { OrderEntryWidget } from '../../components/widgets/PlaceOrders';
import TradeTable from '../../components/widgets/NewTradeTable';
import OrderBookWidget from '../../components/widgets/OrderBookWidgetss';
import ChartWidget from '../../components/widgets/ChartWidget';
import AuctionWidget from '../../components/widgets/AuctionWidget';
import EquitiesDashboard from '../../components/widgets/EquityDashboard';
import {
    getBuildupData,
    getTickers,
    HTTPStatusCodes,
    subscribeToTickers,
    unsubscribeFromTickers,
} from '../../lib/api';
import MessageViewer from '../../components/widgets/MessageViewer';
import PnLWidget from '../../components/widgets/PnLWidget';
import RealizedPnLWidget from '../../components/widgets/realisedPnLWidget';
import Profile from '../../components/widgets/Profile';

function useEtClock() {
    const [time, setTime] = useState('');
    useEffect(() => {
        const tick = () => {
            setTime(
                new Intl.DateTimeFormat('en-US', {
                    timeZone: 'America/New_York',
                    hour: '2-digit',
                    minute: '2-digit',
                    second: '2-digit',
                    hour12: false,
                }).format(new Date()) + ' ET',
            );
        };
        tick();
        const id = setInterval(tick, 1000);
        return () => clearInterval(id);
    }, []);
    return time;
}

const NewDashboard = () => {
    const [selectedStock, setSelectedStock] = useState(getTickers()[0] || 'AAPL');
    const time = useEtClock();
    const username = localStorage.getItem('username') || '';

    const didCheckAuthRef = useRef(false);
    const navigate = useNavigate();

    useEffect(() => {
        if (didCheckAuthRef.current) return;
        didCheckAuthRef.current = true;

        const data = getBuildupData();
        if (data === null || data.status !== HTTPStatusCodes.OK) {
            navigate('/');
        }
    }, [navigate]);

    useEffect(() => {
        const handleTickerUpdate = (newTickers: string[]) => {
            setSelectedStock((current) =>
                newTickers.includes(current) ? current : newTickers[0] || '',
            );
        };

        subscribeToTickers(handleTickerUpdate);
        return () => {
            unsubscribeFromTickers(handleTickerUpdate);
        };
    }, []);

    return (
        <div className="exchange-root">
            {/* ── Exchange Navbar ──────────────────────────────── */}
            <nav className="exchange-navbar">
                <div className="navbar-brand">
                    <span className="navbar-logo">◈</span>
                    <span className="navbar-name">Simulation Exchange</span>
                </div>
                <div className="navbar-right">
                    <span className="navbar-clock">{time}</span>
                    <Link to="/leaderboard" className="navbar-link">
                        Leaderboard
                    </Link>
                    {username && <span className="navbar-user">{username}</span>}
                </div>
            </nav>

            {/* ── Dashboard Grid ───────────────────────────────── */}
            <div className="dashboard">
                {/* COLUMN 1 */}
                <div className="column-1">
                    {/* PNL WIDGET */}
                    <div className="widget pnl-Widget-wrapper">
                        <PnLWidget />
                    </div>

                    {/* BALANCE WIDGET */}
                    <div className="widget pnl-Widget-wrapper">
                        <RealizedPnLWidget />
                    </div>

                    {/* EQUITIES WATCHLIST */}
                    <div className="widget equities">
                        <EquitiesDashboard
                            selectedStock={selectedStock}
                            setSelectedStock={setSelectedStock}
                        />
                    </div>

                    {/* AUCTION + PROFILE */}
                    <div className="Profile-Features">
                        <div className="auctionWidget">
                            <AuctionWidget />
                        </div>
                        <div className="profileWidget">
                            <Profile />
                        </div>
                    </div>

                    {/* MESSAGE LOG */}
                    <div className="widget messageViewer">
                        <MessageViewer />
                    </div>
                </div>

                {/* COLUMN 2 */}
                <div className="column-2">
                    {/* ORDER ENTRY */}
                    <div className="widget position-info">
                        <OrderEntryWidget selectedStock={selectedStock} />
                    </div>

                    {/* CHART */}
                    <div className="widget chart">
                        <ChartWidget selectedStock={selectedStock} />
                    </div>

                    {/* POSITIONS & OPEN ORDERS */}
                    <div className="widget trade-table">
                        <TradeTable />
                    </div>
                </div>

                {/* COLUMN 3 */}
                <div className="column-3">
                    <div className="widget order-book">
                        <OrderBookWidget selectedStock={selectedStock} />
                    </div>
                </div>
            </div>
        </div>
    );
};

export default NewDashboard;
